import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest} from '../../api/ApiController';
import { buildOtkErrorRecordShareUrl } from '../../utils/otkErrorRecordNavigation';
import { SaveIcon, AddIcon, CopyIcon, DeleteIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, PaperClipIcon, CopyLinkIcon} from "../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import EightDreport from "../print/EightDreport";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton';
import { InfinitySpin } from  'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import UtilContext from "../../components/UtilContext";
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import { LocaleContext } from '../../components/LocaleContext';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';
import { getCurrency } from '../../utils/moduleSettings';
import { getPusherChannel } from '../../utils/pusherChannel';
import {
    appendErrorRecordWritePayload,
    collectErrorRecordChangedFields,
    emitErrorRecordListMutation,
} from '../../utils/errorRecordListSync';

export default function ExternaChyba({error_record,er_type}) {
    
    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {locale,t} = useContext(LocaleContext);
    const {openFavoriteDialog,toast,setFastView,openFilePreview} = useContext(UtilContext);

    const [offenderDepartment, setOffenderDepartment] = useState();
    const [offenders, setOffenders] = useState([]);
    const [recordProcessorDepartment, setRecordProcessorDepartment] = useState();
    const [recordProcessors, setRecordProcessors] = useState([]);
    const [auditorDepartment, setAuditorDepartment] = useState();
    const [auditors, setAuditors] = useState([]);
    const [images, setImages] = useState(null);
    const [protocols, setProtocols] = useState(null);

    const [formErrorRecord,setFormErrorRecord] = useState(error_record);
    const [errorRecordType, setErrorRecordType] = useState(er_type);
    const [fileList, setFileList] = useState([]);

    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add otk-section1") || error_record.contractor_id==user.employee.id)?false:true);
    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [scrollIcons,setScrollIcons] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);

    const [closeTab,setCloseTab] = useState(false);
    const closeAfterRef = useRef(false);

    const submitRef = useRef(null);
    const componentRef = useRef(null);
    const fileListRef = useRef(null);
    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });

    async function copyLink(){
        await navigator.clipboard.writeText(buildOtkErrorRecordShareUrl('ExternaChyba', error_record.id))
        .then(() => {
          toast?.current?.show({ severity: 'info', summary: t('Common.Clipboard'), life: 3000, detail: t('Common.CopiedToClipboard') });
          setTimeout(() => {
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    useEffect(() => {
        if (formErrorRecord != null) {
            if (user.permissions?.includes("edit otk-section2")) setScrollIcons(false);
            setDepartmentsWithEmployees();
        }
        const recordId = formErrorRecord?.id;
        if (formErrorRecord != null && errorRecordType === "edit" && recordId) {
            setImages(null);
            setProtocols(null);
            getRequest(`/api/error_records/images/${recordId}`)
                .then((response) => {
                    const data = response?.data ?? response;
                    setImages(Array.isArray(data) ? data : []);
                })
                .catch(() => setImages([]));
            getRequest(`/api/error_records/protocols/${recordId}`)
                .then((response) => {
                    const data = response?.data ?? response;
                    setProtocols(data && typeof data === "object" ? data : {});
                })
                .catch(() => setProtocols({}));
        }
    }, [formErrorRecord?.id, errorRecordType]);

    useEffect(() => {
        const recordId = formErrorRecord?.id;
        if (recordId == null) return;
        const channel = getPusherChannel();
        if (!channel) return;
        const onUpdated = (data) => {
            const id = data?.id ?? null;
            if (id == null || Number(id) !== Number(recordId)) return;
            getRequest(`/api/error_records/${recordId}`)
                .then((res) => {
                    const d = res?.data ?? res;
                    if (d) setFormErrorRecord(d);
                })
                .catch(() => {});
        };
        const onDeleted = (data) => {
            const id = data?.id ?? null;
            if (id != null && Number(id) === Number(recordId)) {
                dispatch({ type: 'close_tab', id: state.selectedTab });
            }
        };
        channel.bind('error_record.updated', onUpdated);
        channel.bind('error_record.deleted', onDeleted);
        return () => {
            channel.unbind('error_record.updated', onUpdated);
            channel.unbind('error_record.deleted', onDeleted);
        };
    }, [formErrorRecord?.id, dispatch, state.selectedTab]);

    function setDepartmentsWithEmployees(){
        if(formErrorRecord.offender_id){
            const offender = state.offenders.filter((offender) => {
                if(offender.employee && offender.employee.offender_id === formErrorRecord.offender_id){
                    let edit_offender = offender;
                    edit_offender.department = offender.employee.department_id;
                    return edit_offender;
                }
                if(offender.supplier && offender.supplier.supplier_offender_id === formErrorRecord.offender_id){
                    let edit_offender = offender;
                    edit_offender.department = t('Common.Supplier');
                    return edit_offender;
                }
                if(offender.customer && offender.customer.customer_offender_id === formErrorRecord.offender_id){
                    let edit_offender = offender;
                    edit_offender.department = t('Common.Customer');
                    return edit_offender;
                }
                return false;
            });
            if(offender.length>0)filterOffenders(offender[0].department);
        }
        if(formErrorRecord.record_processor_id){
            const record_processor = state.employees.filter(record_processor => record_processor.id === formErrorRecord.record_processor_id);
            filterRecordProcessors(record_processor[0].department.id);
        }
        if(formErrorRecord.auditor_id){
            const auditor = state.employees.filter(auditor => auditor.id === formErrorRecord.auditor_id);
            filterAuditors(auditor[0].department.id);
        }
    }

    function loadGalleryAndProtocols(recordId) {
        const id = recordId ?? formErrorRecord?.id ?? formik?.values?.id;
        if (!id) return;
        setImages(null);
        setProtocols(null);
        getRequest(`/api/error_records/images/${id}`)
            .then((response) => {
                const data = response?.data ?? response;
                setImages(Array.isArray(data) ? data : []);
            })
            .catch(() => setImages([]));
        getRequest(`/api/error_records/protocols/${id}`)
            .then((response) => {
                const data = response?.data ?? response;
                setProtocols(data && typeof data === "object" ? data : {});
            })
            .catch(() => setProtocols({}));
    }

    /* validate form */
    const validate = values => {
        const errors = {};
        if (!values.type) {
            errors.type = t('Common.RequiredField');
        }
        if (values.state === 'Zatvorená' && values.ack_error !== 'Uznaná' && values.ack_error !== 'Neuznaná') {
            errors.ack_error = t('Otk.CloseRequiresRecognition');
        }
        return errors;
    };

    const emptyErrorRecordValues = {
        type: "Externá chyba",
        article_number: '',
        article_name: '',
        order_number: '',
        customer_id: '',
        offender_id: '',
        repair_costs: '25',
        total_amount: '',
        defective_pieces: '',
        group_id: '',
        ack_error: '',
        claim_counterparty_number: '',
        error_type_id: '',
        contractor_note: '',
        record_processor_id: '',
        problem_description: '',
        main_reason: '',
        immediate_measure: '',
        long_term_measure: '',
        prevention_id: '',
        root_cause_id: '',
        auditor_id: '',
        auditor_note: '',
        state: t('Status.OpenFemale'),
    };

    function formValuesFromRecord(record) {
        if (record == null) return { ...emptyErrorRecordValues };
        return {
            id: record.id,
            type: record.type ?? t('Otk.ExternalError'),
            article_number: record.article_number ?? '',
            article_name: record.article_name ?? '',
            order_number: record.order_number ?? '',
            customer_id: record.customer_id ?? '',
            offender_id: record.offender_id ?? '',
            repair_costs: record.repair_costs ?? '',
            total_amount: record.total_amount ?? '',
            defective_pieces: record.defective_pieces ?? '',
            group_id: record.group_id ?? '',
            ack_error: record.ack_error ?? '',
            claim_counterparty_number: record.claim_counterparty_number ?? '',
            error_type_id: record.error_type_id ?? '',
            contractor_id: record.contractor_id ?? '',
            contractor_note: record.contractor_note ?? '',
            record_processor_id: record.record_processor_id ?? '',
            problem_description: record.problem_description ?? '',
            main_reason: record.main_reason ?? '',
            immediate_measure: record.immediate_measure ?? '',
            long_term_measure: record.long_term_measure ?? '',
            prevention_id: record.prevention_id ?? '',
            root_cause_id: record.root_cause_id ?? '',
            auditor_id: record.auditor_id ?? '',
            auditor_note: record.auditor_note ?? '',
            state: record.state ?? t('Status.OpenFemale'),
        };
    }

    const formik = useFormik({
        initialValues: formValuesFromRecord(formErrorRecord),
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            const submitted = formValuesFromRecord(values);
            const hadUserEdits = formik.dirty || fileList.length > 0;
            const closeAfterSave = closeAfterRef.current;
            let formData = new FormData();
            const extras = errorRecordType === 'add'
                ? { contractor_id: user?.employee?.id ? user.employee.id : submitted.record_processor_id }
                : {};
            appendErrorRecordWritePayload(formData, submitted, extras);
            for (let i = 0; i < fileList.length; i++) {
                formData.append('files[]', fileList[i]);
            }
            if(errorRecordType=="add"){
                postRequest('/api/error_records', formData,true)
                .then((response_first) => {
                    const newId = response_first?.data?.id;
                    const emitCreate = (row) => {
                        emitErrorRecordListMutation({
                            operation: 'create',
                            id: newId ?? row?.id ?? null,
                            row: row || null,
                            changedFields: [],
                        });
                    };
                    if (closeAfterSave) dispatch({type:'close_tab',id:state.selectedTab});
                    if (fileList.length && newId) {
                        loadGalleryAndProtocols(newId);
                        setFileList([]);
                        if (fileListRef.current) fileListRef.current.value = null;
                    }
                    if (newId) {
                        getRequest(`/api/error_records/${newId}`).then((r) => {
                            const full = r?.data ?? r;
                            setFormErrorRecord(full);
                            setErrorRecordType("edit");
                            formik.setValues(formValuesFromRecord(full));
                            emitCreate(full);
                            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                        }).catch(() => {
                            setFormErrorRecord(response_first.data);
                            setErrorRecordType("edit");
                            emitCreate(response_first.data);
                            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                        });
                    } else {
                        setErrorRecordType("edit");
                        emitCreate(null);
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    }
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
            else{
                postRequest(`/api/error_records/update/${formik.values.id}`, formData,true)
                .then((response_first) => {
                    const saved = response_first?.data;
                    const attachedFiles = fileList.length > 0;
                    if (closeAfterSave) dispatch({type:'close_tab',id:state.selectedTab});
                    formik.setValues(submitted);
                    if (attachedFiles && saved?.id) {
                        loadGalleryAndProtocols(saved.id);
                        setFileList([]);
                        if (fileListRef.current) fileListRef.current.value = null;
                    }
                    if (!hadUserEdits) {
                        return;
                    }
                    const recordId = submitted?.id ?? formik.values.id;
                    const changedFields = collectErrorRecordChangedFields(formik.initialValues, submitted, {
                        implicitAudit: true,
                        hasFiles: attachedFiles,
                    });
                    const finish = (mutation) => {
                        if (mutation) emitErrorRecordListMutation(mutation);
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    };
                    if (recordId == null) {
                        finish({ operation: 'update', id: null, row: null, changedFields });
                        return;
                    }
                    getRequest(`/api/error_records/${recordId}`).then((r) => {
                        const full = r?.data ?? r;
                        setFormErrorRecord(full);
                        formik.setValues(formValuesFromRecord(full));
                        finish({
                            operation: 'update',
                            id: recordId,
                            row: full && typeof full === 'object' ? full : null,
                            changedFields,
                        });
                    }).catch(() => {
                        finish({ operation: 'update', id: recordId, row: saved || null, changedFields });
                    });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });

    const handleFileChange = (event) => {
        setFileList(event.target.files);
    };

    function addNewExtError(){
        dispatch({type:'create_new_tab',name: t('Otk.NewExternalErrorUpper'), translationKey: 'Otk.NewExternalErrorUpper', legacyLabel: t('Otk.NewExternalErrorUpper'),page:'ExternaChyba',mask:'qlty005'})
    }

    function copyExtError(){
        dispatch({type:'create_new_tab',name: t('Otk.NewExternalErrorUpper'), translationKey: 'Otk.NewExternalErrorUpper', legacyLabel: t('Otk.NewExternalErrorUpper'),page:'ExternaChyba',props:{error_record: formik.values,er_type:'add'},mask:'qlty005'})
    }

    /* filter offender by department in form */
    function filterOffenders(department){
        setOffenderDepartment(department);
        if(department === "Zákazník"){
            setOffenders(state.offenders
            .filter(offender => offender.type === 'customer')
            .map(offender => offender.customer));
        }
        else if(department === "Dodávateľ"){
            setOffenders(state.offenders
                .filter(offender => offender.type === 'supplier')
                .map(offender => offender.supplier));
        }
        else if(department === ""){
            setOffenders([]);
        }
        else{
            setOffenders(state.offenders
                .filter(offender => offender.type === 'employee')
                .filter(offender => offender.employee?.department_id === parseInt(department))
                .map(offender => offender.employee));
        }
    }

    /* filter record processors by department in form */
    function filterRecordProcessors(departmentId){
        setRecordProcessorDepartment(departmentId);
        setRecordProcessors(state.employees
        .filter(employee => employee.department.id === parseInt(departmentId)));
    }

    /* filter auditors by department in form */
    function filterAuditors(departmentId){
        setAuditorDepartment(departmentId);
        setAuditors(state.employees
        .filter(employee => employee.department.id === parseInt(departmentId)));
    }

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(state.error_records_ext, formErrorRecord?.id, setFormErrorRecord),
        [state.error_records_ext, formErrorRecord?.id]
    );

    function editIntError(error_record){
        dispatch({type:'create_new_tab',name: t('Otk.EditInternalErrorUpper'), translationKey: 'Otk.EditInternalErrorUpper', legacyLabel: t('Otk.EditInternalErrorUpper'),page:'InternaChyba',props:{error_record: error_record,er_type:'edit'}})
      }

      function editRekError(error_record){
        dispatch({type:'create_new_tab',name: t('Otk.EditComplaintUpper'), translationKey: 'Otk.EditComplaintUpper', legacyLabel: t('Otk.EditComplaintUpper'),page:'Reklamacia',props:{error_record: error_record,er_type:'edit'}})
    }

    function showDocumentation(item){
        dispatch({type:'create_new_tab',name: t('Otk.DocumentationDetail'), translationKey: 'Otk.DocumentationDetail', legacyLabel: t('Otk.DocumentationDetail'),page:'DocumentationDetail',props:{measure: item,name:t('Otk.DocType.Documentation'),type:'edit',not_last_used: true}})
    }

    function showSelfControl(item){
        dispatch({type:'create_new_tab',name: t('MeasureGroupList.Tab.SelfControlDetail'), translationKey: 'MeasureGroupList.Tab.SelfControlDetail', legacyLabel: t('MeasureGroupList.Tab.SelfControlDetail'),page:'DocumentationDetail',props:{measure: item,name:'SEBAKONTROLA',type:'edit',not_last_used: true}})
    }

    function showMeasurementProtocol(item){
        dispatch({type:'create_new_tab',name: t('Otk.MeasuringProtocolDetail'), translationKey: 'Otk.MeasuringProtocolDetail', legacyLabel: t('Otk.MeasuringProtocolDetail'),page:'DocumentationDetail',props:{measure: item,name:t('Otk.DocType.MeasuringProtocol'),type:'edit',not_last_used: true}})
    }

    function showNDTProtocol(item){
        dispatch({type:'create_new_tab',name: t('MeasureGroupList.Tab.NdtProtocolDetail'), translationKey: 'MeasureGroupList.Tab.NdtProtocolDetail', legacyLabel: t('MeasureGroupList.Tab.NdtProtocolDetail'),page:'DocumentationDetail',props:{measure: item,name:'NDT PROTOKOL',type:'edit',not_last_used: true}})
    }

    function showAnnealingProtocol(item){
        dispatch({type:'create_new_tab',name: t('Otk.AnnealingProtocolDetail'), translationKey: 'Otk.AnnealingProtocolDetail', legacyLabel: t('Otk.AnnealingProtocolDetail'),page:'DocumentationDetail',props:{measure: item,name:t('Otk.DocType.AnnealingProtocol'),type:'edit',not_last_used: true}})
    }

    const accept = (id) => {
        getRequest(`/api/error_records/deleteImage/${id}`)
            .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('ServiceTaskDetail.Toast.FileDeleted') });
              loadGalleryAndProtocols();
            }).catch((reason) => {
                alert(reason);
                toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceTaskDetail.Toast.FileDeleteFailed'), life: 3000 });
            })
      };

      const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('ServiceTask.Rejected'), detail: t('ServiceTask.RequestCancelled'), life: 3000 });
      }
  

  function deleteFiles(img){
      confirmDialog({
          message: t('ServiceTask.DeleteFilePrompt'),
          header: t('Common.ConfirmDelete'),
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: t('Common.No'),
          rejectLabel: t('Common.Yes'),
          accept:reject,
          reject:() => accept(img.id)
      });
  }

    return (
        <div>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="saveandclose"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => { closeAfterRef.current = true; setCloseTab(true); submitRef.current.click(); }}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="save"><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => { closeAfterRef.current = false; setCloseTab(false); submitRef.current.click(); }}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewExtError()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyExtError()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => handlePrint()}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy_link"><button onClick={() => copyLink()}><CopyLinkIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Otk.ExternalError'),"ExternaChyba")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("ExternaChyba")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><VerticalLineIcon/></div>
          </IntersectionObserverWrapper>
        </div>
        <div className='overflow-y-auto h-[calc(100vh-177px)]'>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col justify-left overflow-x">
          <div className="xl:grid grid-cols-3 gap-1 mb-2 ">
            <div className={`w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md`}>
                { !user.permissions?.includes("add otk-section1") && 
                <div className='w-full h-8 flex justify-center px-2 py-1 mb-2'>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
                            <path d="M 25 3 C 18.363281 3 13 8.363281 13 15 L 13 20 L 9 20 C 7.355469 20 6 21.355469 6 23 L 6 47 C 6 48.644531 7.355469 50 9 50 L 41 50 C 42.644531 50 44 48.644531 44 47 L 44 23 C 44 21.355469 42.644531 20 41 20 L 37 20 L 37 15 C 37 8.363281 31.636719 3 25 3 Z M 25 5 C 30.566406 5 35 9.433594 35 15 L 35 20 L 15 20 L 15 15 C 15 9.433594 19.433594 5 25 5 Z M 9 22 L 41 22 C 41.554688 22 42 22.445313 42 23 L 42 47 C 42 47.554688 41.554688 48 41 48 L 9 48 C 8.445313 48 8 47.554688 8 47 L 8 23 C 8 22.445313 8.445313 22 9 22 Z M 25 30 C 23.300781 30 22 31.300781 22 33 C 22 33.898438 22.398438 34.6875 23 35.1875 L 23 38 C 23 39.101563 23.898438 40 25 40 C 26.101563 40 27 39.101563 27 38 L 27 35.1875 C 27.601563 34.6875 28 33.898438 28 33 C 28 31.300781 26.699219 30 25 30 Z"></path>
                        </svg>
                    </div> }
                <h1 className="text-2xl font-semibold text-left text-zinc-900">{t('OTKEvaluation.ExternaChyba2')}</h1>
                {errorRecordType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.specific_id}</label>}
                <div className="mt-6">
                {/* Prvá sekcia*/}
                    <div className="md:grid grid-cols-2 gap-1 mb-2">
                      <div>
                        <label
                            htmlFor="article_number"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Artikel
                        </label>
                        <input
                            required
                            name='article_number'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.article_number}
                            readOnly={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="article_name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.ArticleName')}</label>
                        <input
                            name='article_name'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.article_name}
                            readOnly={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                      <div>
                        <label
                            htmlFor="order_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Zakazka')}</label>
                        <input
                            required
                            name='order_number'
                            type="number"
                            onChange={formik.handleChange} value={formik.values.order_number}
                            readOnly={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="customer_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Customer')}</label>
                        <select 
                        name='customer_id'
                        onChange={formik.handleChange} value={formik.values.customer_id}
                        disabled={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('Common.SelectCustomer')}</option>
                          {state.companies.filter(comp => comp.types.includes("customer")).map((customer) => (
                            <option key={customer.id} value={customer.id}>{customer.name}</option>
                          ))}                          
                        </select>
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                      <div>
                        <label
                            htmlFor="offenderDepartment"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.OffenderDepartmentLabel')}</label>
                        <select 
                        required
                        name='offenderDepartment'
                        onChange={(e) => filterOffenders(e.target.value)} value={offenderDepartment}
                        disabled={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                           <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                           {state.departments.map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                          ))}
                          <option value="Zákazník">{t('Common.Customer')}</option>
                          <option value="Dodávateľ">{t('Common.Supplier')}</option>
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="offender_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Vinnik')}</label>
                        <select 
                        required
                        name='offender_id'
                        onChange={formik.handleChange} value={formik.values.offender_id}
                        disabled={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                        
                        <option value="">{t('Common.SelectEmployee')}</option>
                        {offenders.filter(offender => offender?.offender_id != null).map((offender) => (
                        <option key={offender?.offender_id} value={offender?.offender_id}>{offender?.name}</option>
                        ))}
                        {offenders.filter(offender => offender?.supplier_offender_id != null).map((offender) => (
                        <option key={offender?.supplier_offender_id} value={offender?.supplier_offender_id}>{offender?.name}</option>
                        ))}
                        {offenders.filter(offender => offender?.customer_offender_id != null).map((offender) => (
                        <option key={offender?.customer_offender_id} value={offender?.customer_offender_id}>{offender?.name}</option>
                        ))}
                        </select>
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                      <div>
                        <label
                            htmlFor="repair_costs"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Náklady ({getCurrency(state.module_settings || [])})
                        </label>
                        <input
                            type="text"
                            name='repair_costs'
                            onChange={formik.handleChange} value={formik.values.repair_costs}
                            readOnly={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="ack_error"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Chyba
                        </label>
                        <select 
                        name='ack_error'
                        onChange={formik.handleChange} value={formik.values.ack_error}
                        disabled={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('Common.SelectOption')}</option>
                          <option value="Uznaná">{t("Uznaná")}</option>
                          <option value="Neuznaná">{t("Neuznaná")}</option>
                        </select>
                        {formik.errors.ack_error && <p className="text-red-600 text-sm mt-1">{formik.errors.ack_error}</p>}
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                      <div>
                        <label
                            htmlFor="total_amount"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Mnozstvo')}</label>
                        <input
                            required
                            type="number"
                            name='total_amount'
                            onChange={formik.handleChange} value={formik.values.total_amount}
                            readOnly={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="error_type_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Druh chyby
                        </label>
                        <select 
                        required
                        name='error_type_id'
                        onChange={formik.handleChange} value={formik.values.error_type_id}
                        disabled={!user.permissions?.includes("add otk-section1")} 
                        className={` ${
                            user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                        } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                           <option value="">{t('Ui.R67.SelectErrorType')}</option>
                           {state.error_types.map((error_type) => (
                            <option key={error_type.id} value={error_type.id}>
                                {error_type.name[locale] || error_type.name.sk} 
                            </option>
                            ))}
                        </select>
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                      <div>
                        <label
                            htmlFor="defective_pieces"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.DefectiveCount')}</label>
                        <input
                            required
                            name='defective_pieces'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.defective_pieces}
                            readOnly={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="group_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Skupina
                        </label>
                        <select 
                        required
                        name='group_id'
                        onChange={formik.handleChange} value={formik.values.group_id}
                        disabled={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('Ui.R67.SelectGroup')}</option>
                          {state.groups.map((group) => (
                            <option key={group.id} value={group.id}>
                                {group.name[locale] || group.name.sk} 
                            </option>
                            ))}
                        </select>
                        </div>
                    </div>
                    <div>
                        <label
                            htmlFor="claim_counterparty_number"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.CounterpartyComplaintNumber')}</label>
                        <input
                            name='claim_counterparty_number'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.claim_counterparty_number}
                            disabled={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        {/*<div>
                        <label
                            htmlFor="contractor_note"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Note')}</label>
                        <textarea
                            name='contractor_note'
                            onChange={formik.handleChange} value={formik.values.contractor_note}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                          </div>*/}
                        <div>
                        <label
                            htmlFor="problem_description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.ProblemDescription')}</label>
                        <textarea
                            required
                            name="problem_description" type="text" onChange={formik.handleChange} value={formik.values.problem_description}
                            disabled={!user.permissions?.includes("add otk-section1")} 
                            className={` ${
                                user.permissions?.includes("add otk-section1") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                </div>           
            </div>
            <div className={`w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md`}>
                { !user.permissions?.includes("add otk-section2") && 
            <div className='w-full h-8 flex justify-center px-2 py-1 mb-2'>
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
                        <path d="M 25 3 C 18.363281 3 13 8.363281 13 15 L 13 20 L 9 20 C 7.355469 20 6 21.355469 6 23 L 6 47 C 6 48.644531 7.355469 50 9 50 L 41 50 C 42.644531 50 44 48.644531 44 47 L 44 23 C 44 21.355469 42.644531 20 41 20 L 37 20 L 37 15 C 37 8.363281 31.636719 3 25 3 Z M 25 5 C 30.566406 5 35 9.433594 35 15 L 35 20 L 15 20 L 15 15 C 15 9.433594 19.433594 5 25 5 Z M 9 22 L 41 22 C 41.554688 22 42 22.445313 42 23 L 42 47 C 42 47.554688 41.554688 48 41 48 L 9 48 C 8.445313 48 8 47.554688 8 47 L 8 23 C 8 22.445313 8.445313 22 9 22 Z M 25 30 C 23.300781 30 22 31.300781 22 33 C 22 33.898438 22.398438 34.6875 23 35.1875 L 23 38 C 23 39.101563 23.898438 40 25 40 C 26.101563 40 27 39.101563 27 38 L 27 35.1875 C 27.601563 34.6875 28 33.898438 28 33 C 28 31.300781 26.699219 30 25 30 Z"></path>
                    </svg>
                </div> }
                <h1 className="text-xl font-semibold text-left mt-3 text-zinc-900">
                   Spracovanie externej chyby
                </h1>
                <div className="mt-6">
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                      <div>
                        <label
                            htmlFor="recordProcessorDepartment"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Department')}</label>
                        <select 
                        required
                        name='offenderDepartment'
                        onChange={(e) => filterRecordProcessors(e.target.value)} value={recordProcessorDepartment}
                        disabled={!user.permissions?.includes("add otk-section2")} 
                        className={` ${
                            user.permissions?.includes("add otk-section2") ? "bg-white " : "bg-gray-200 "
                        } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                          {state.departments.map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                            ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="record_processor_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Zamestnanec
                        </label>
                        <select 
                        required
                        name="record_processor_id"
                        onChange={formik.handleChange} value={formik.values.record_processor_id}
                        disabled={!user.permissions?.includes("add otk-section2")} 
                        className={` ${
                            user.permissions?.includes("add otk-section2") ? "bg-white " : "bg-gray-200 "
                        } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('Common.SelectEmployee')}</option>
                          {recordProcessors.map((recordProcessor) => (
                            <option key={recordProcessor.id} value={recordProcessor.id}>{recordProcessor.name}</option>
                            ))}
                        </select>
                        </div>
                    </div>
                        <div>
                        <label
                            htmlFor="main_reason"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.MainCause')}</label>
                        <textarea
                            name="main_reason" type="text" onChange={formik.handleChange} value={formik.values.main_reason}
                            readOnly={!user.permissions?.includes("add otk-section2")} 
                            className={` ${
                                user.permissions?.includes("add otk-section2") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="immediate_measure"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.ImmediateAction')}</label>
                        <textarea
                            name="immediate_measure" type="text" onChange={formik.handleChange} value={formik.values.immediate_measure}
                            readOnly={!user.permissions?.includes("add otk-section2")} 
                            className={` ${
                                user.permissions?.includes("add otk-section2") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="long_term_measure"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.LongTermAction')}</label>
                        <textarea
                            name="long_term_measure" type="text" onChange={formik.handleChange} value={formik.values.long_term_measure}
                            readOnly={!user.permissions?.includes("add otk-section2")} 
                            className={` ${
                                user.permissions?.includes("add otk-section2") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="prevention_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Zabranenie_opakovania_chyby_skrz')}</label>
                        <select 
                        name="prevention_id" onChange={formik.handleChange} value={formik.values.prevention_id}
                        disabled={!user.permissions?.includes("add otk-section2")} 
                        className={` ${
                            user.permissions?.includes("add otk-section2") ? "bg-white " : "bg-gray-200 "
                        } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('Ui.R67.Vyber_zabranenie')}</option>
                          {state.preventions.map((prevention) => (
                            <option key={prevention.id} value={prevention.id}>
                                {prevention.name[locale] || prevention.name.sk} 
                            </option>                            
                           ))}
                        </select>
                        </div>
                        <div>
                            <label
                                htmlFor="root_cause_id"
                                className="block text-md font-semibold text-gray-800"
                            >{t('Ui.R67.RootCause')}</label>
                            <select 
                            name="root_cause_id" onChange={formik.handleChange} value={formik.values.root_cause_id}
                            disabled={!user.permissions?.includes("add otk-section2")} 
                            className={` ${
                                user.permissions?.includes("add otk-section2") ? "bg-white " : "bg-gray-200 "
                            } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                            <option value="">{t('OTKEvaluation.VyberPricinu')}</option>
                            {state?.root_causes?.map((root_cause) => (
                                <option key={root_cause.id} value={root_cause.id}>
                                    {root_cause.name[locale] || root_cause.name.sk} 
                                </option>                            
                            ))}
                            </select>
                        </div>
                        {errorRecordType == "edit" && 
                        <>
                        <label className='block text-md font-semibold text-gray-800 w-full'>{t('Ui.R67.Prilohy')}</label>
                        {protocols === null && (
                            <div className="w-full space-y-2 py-2">
                                <Skeleton height="2.5rem" className="w-full" />
                                <Skeleton height="2.5rem" className="w-full" />
                                <Skeleton height="2.5rem" className="w-full" />
                                <Skeleton height="2.5rem" className="w-full" />
                            </div>
                        )}
                        {protocols !== null && <div className="w-full px-4 py-2 mb-2 ">
                                    <table className='w-full border border-separate border-gray-400 rounded-md bg-white'>
                                        <tr>
                                            <td className=''>Interná chyba:</td>
                                            <td className='flex flex-wrap justify-end'>
                                            {state.error_records_int.filter((item) => item.order_number == formErrorRecord.order_number)?.map((item) => (
                                                    <button type="button" className='cursor-pointer' onClick={() => editIntError(item)}><PaperClipIcon/>
                                                    </button>
                                                ))}
                                                </td>
                                        </tr>
                                    </table>
                                    <table className='w-full border border-separate border-gray-400 rounded-md bg-white'>
                                        <tr>
                                            <td>Reklamácia:</td>
                                            <td className='flex flex-wrap justify-end'>
                                            {state.error_records_rek.filter((item) => item.order_number == formErrorRecord.order_number)?.map((item) => (
                                                    <button type="button" className='cursor-pointer' onClick={() => editRekError(item)}><PaperClipIcon/>
                                                    </button>
                                                ))}</td>
                                        </tr>
                                    </table>
                                    <table className='w-full border border-separate border-gray-400 rounded-md bg-white'>
                                        <tr>
                                            <td>Dokumentácia:</td>
                                            <td className='flex flex-wrap justify-end'>
                                                {protocols?.documentation?.map((item) => (
                                                    <button type="button" className='cursor-pointer' onClick={() => showDocumentation(item)}><PaperClipIcon/>
                                                    </button>
                                                ))}
                                            </td>
                                        </tr>
                                    </table>
                                    <table className='w-full border border-separate border-gray-400 rounded-md bg-white'>
                                        <tr>
                                            <td>Sebakontrola:</td>
                                            <td className='flex flex-wrap justify-end'>
                                            {protocols?.self_control?.map((item) => (
                                                    <button type="button" className='cursor-pointer' onClick={() => showSelfControl(item)}><PaperClipIcon/>
                                                    </button>
                                                ))}
                                            </td>
                                        </tr>
                                    </table>
                                    <table className='w-full border border-separate border-gray-400 rounded-md bg-white'>
                                        <tr>
                                            <td>Merací protokol:</td>
                                            <td className='flex flex-wrap justify-end'>
                                            {protocols?.measurement_protocol?.map((item) => (
                                                    <button type="button" className='cursor-pointer' onClick={() => showMeasurementProtocol(item)}><PaperClipIcon/>
                                                    </button>
                                                ))}
                                            </td>
                                        </tr>
                                    </table>
                                    <table className='w-full border border-separate border-gray-400 rounded-md bg-white'>
                                        <tr>
                                            <td>NDT protokol:</td>
                                            <td className='flex flex-wrap justify-end'>
                                            {protocols?.ndt_protocol?.map((item) => (
                                                    <button type="button" className='cursor-pointer' onClick={() => showNDTProtocol(item)}><PaperClipIcon/>
                                                    </button>
                                                ))}
                                            </td>
                                        </tr>
                                    </table>
                                    <table className='w-full border border-separate border-gray-400 rounded-md bg-white'>
                                        <tr>
                                            <td>Žihací protokol:</td>
                                            <td className='flex flex-wrap justify-end'>
                                            {protocols?.annealing_protocol?.map((item) => (
                                                    <button type="button" className='cursor-pointer' onClick={() => showAnnealingProtocol(item)}><PaperClipIcon/>
                                                    </button>
                                                ))}
                                            </td>
                                        </tr>
                                    </table>
                            </div>}</>}
                </div>           
            </div>
            <div className={`w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md`}>
                { !user.permissions?.includes("add otk-section3") && 
            <div className='w-full h-8 flex justify-center px-2 py-1 mb-2'>
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
                        <path d="M 25 3 C 18.363281 3 13 8.363281 13 15 L 13 20 L 9 20 C 7.355469 20 6 21.355469 6 23 L 6 47 C 6 48.644531 7.355469 50 9 50 L 41 50 C 42.644531 50 44 48.644531 44 47 L 44 23 C 44 21.355469 42.644531 20 41 20 L 37 20 L 37 15 C 37 8.363281 31.636719 3 25 3 Z M 25 5 C 30.566406 5 35 9.433594 35 15 L 35 20 L 15 20 L 15 15 C 15 9.433594 19.433594 5 25 5 Z M 9 22 L 41 22 C 41.554688 22 42 22.445313 42 23 L 42 47 C 42 47.554688 41.554688 48 41 48 L 9 48 C 8.445313 48 8 47.554688 8 47 L 8 23 C 8 22.445313 8.445313 22 9 22 Z M 25 30 C 23.300781 30 22 31.300781 22 33 C 22 33.898438 22.398438 34.6875 23 35.1875 L 23 38 C 23 39.101563 23.898438 40 25 40 C 26.101563 40 27 39.101563 27 38 L 27 35.1875 C 27.601563 34.6875 28 33.898438 28 33 C 28 31.300781 26.699219 30 25 30 Z"></path>
                    </svg>
                </div> }
                <h1 className="text-xl font-semibold text-left text-zinc-900">{t('Ui.R67.Konecna_kontrola_zavedeneho_opatrenia_skrz_OTK')}</h1>
                <div className="mt-6">
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                      <div>
                        <label
                            htmlFor="auditorDepartment"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Department')}</label>
                        <select 
                        name="auditorDepartment" onChange={(e) => filterAuditors(e.target.value)} value={auditorDepartment}
                        disabled={!user.permissions?.includes("add otk-section3")} 
                        className={` ${
                            user.permissions?.includes("add otk-section3") ? "bg-white " : "bg-gray-200 "
                        } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                          {state.departments.map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                            ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="auditor_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Zamestnanec
                        </label>
                        <select 
                        name="auditor_id" onChange={formik.handleChange} value={formik.values.auditor_id}
                        disabled={!user.permissions?.includes("add otk-section3")} 
                        className={` ${
                            user.permissions?.includes("add otk-section3") ? "bg-white " : "bg-gray-200 "
                        } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="">{t('Common.SelectEmployee')}</option>
                          {auditors.map((auditor) => (
                            <option key={auditor.id} value={auditor.id}>{auditor.name}</option>
                            ))}
                        </select>
                        </div>
                    </div>
                        <div>
                        <label
                            htmlFor="auditor_note"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Note')}</label>
                        <textarea
                        name="auditor_note" type="text" onChange={formik.handleChange} value={formik.values.auditor_note}
                        disabled={!user.permissions?.includes("add otk-section3")} 
                        className={` ${
                            user.permissions?.includes("add otk-section3") ? "bg-white " : "bg-gray-200 "
                        } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="state"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Status')}</label>
                        <select 
                        name="state" onChange={formik.handleChange} value={formik.values.state}
                        disabled={!user.permissions?.includes("add otk-section3")} 
                        className={` ${
                            user.permissions?.includes("add otk-section3") ? "bg-white " : "bg-gray-200 "
                        } block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40`}>
                          <option value="Otvorená">{t('Otvorena')}</option>
                          <option value="Zatvorená">{t('Zatvorena')}</option>
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="files"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Subory')}</label>
                          <input
                          accept='image/*,application/pdf,.msg'
                          name='files' 
                          ref={fileListRef}
                          onChange={handleFileChange}
                          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                          type='file'
                          multiple="multiple"
                          id='file'/>
                        </div>
                        <div>
                        <label
                            htmlFor="images"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Checklist.Gallery')}</label>
                        {images === null && (
                            <div className="flex flex-wrap gap-4 py-2">
                                <Skeleton width="100px" height="65px" className="rounded" />
                                <Skeleton width="100px" height="65px" className="rounded" />
                                <Skeleton width="100px" height="65px" className="rounded" />
                            </div>
                        )}
                        {Array.isArray(images) && images.length > 0 && images.map((img) => (<table className='w-full border border-separate border-gray-400 rounded-md bg-white mb-4'>
                            <tr>
                                <td className='text-black h-10'><div className='flex flex-row p-2'>
                                    <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                                        {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg)$/i.test(img.filename || '') ? (
                                            <embed src={img.url+'#view=FitH&scrollbar=0'} width="100px" height="65px" />
                                        ) : (
                                            <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                                        )}
                                    </div>
                                        <div className='flex flex-col ml-4'>
                                        <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                        <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Delete')}</span></button>
                                        </div>
                                    </div></td>
                            </tr>
                        </table>))}
                        </div>
                </div>           
            </div>
            </div>
            <div>
            <input
                name='type'
                type="hidden"
                value={formik.values.type}
            />
            <button type="submit" ref={submitRef} className='hidden'></button>
            {/*<button type="submit" className='w-full px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Common.SaveUpper')}</button>*/}
            </div>
        </div>
        </form>
        <div ref={componentRef} style={{display:'none'}}>
            <EightDreport key={formik.values.id} error_record={formik.values}/>
        </div>
        </div>
        </div>
    );
}